import _ from "lodash";
import {LOGO_IMAGE_DETAIL} from "../constants/shopify.constant";

export {
    processAllImagePositionDetails,
    processImagePositionDetails,
    processTextPositionDetails,
    processAllImageAlignmentAndPositionDetails,
}

const processAllImageAlignmentAndPositionDetails = (cards, settings, fitType = 'height', positionType = 'center-center') => {
    cards.forEach(card => {
        const existingLayers = card?.layers;
        const imageLayerIndex = _.findIndex(existingLayers, {isImageLayer: true});
        const imageLayer = existingLayers[imageLayerIndex];

        if (imageLayer.children) {
            imageLayer.children.forEach(child => {
                processImageAlignmentDetails(fitType, child.props, settings);
                processImagePositionDetails(positionType, child.props, settings);
            });
        }

        existingLayers[imageLayerIndex] = imageLayer;
        card.layers = existingLayers;
    });
}

const processAllImagePositionDetails = (positionType, cards, settings) => {
    cards.forEach(card => {
        const existingLayers = card?.layers;
        const imageLayerIndex = _.findIndex(existingLayers, {isImageLayer: true});
        const imageLayer = existingLayers[imageLayerIndex];

        if (imageLayer.children) {
            imageLayer.children.forEach(child => {
                processImagePositionDetails(positionType, child.props, settings);
            });
        }

        existingLayers[imageLayerIndex] = imageLayer;
        card.layers = existingLayers;
    });
}

const processImageAlignmentDetails = (fitType, imageProps, settings) => {
    let fillPatternScale = settings?.height / imageProps?.height;

    if (fitType === 'height') {
        fillPatternScale = settings?.height / imageProps?.height;
    } else if (fitType === 'width') {
        fillPatternScale = settings?.width / imageProps?.width;
    }

    imageProps.fillPatternScaleX = fillPatternScale;
    imageProps.fillPatternScaleY = fillPatternScale;
    imageProps.width = imageProps?.width * fillPatternScale;
    imageProps.height = imageProps?.height * fillPatternScale;

    if (fitType === 'width') {
        imageProps.y = (settings?.height - imageProps?.height) / 2;
    } else if (fitType === 'height') {
        imageProps.x = (settings?.width - imageProps?.width) / 2;
    }

    imageProps.offsetX = imageProps.fillPatternOffsetX || 0;
    imageProps.offsetY = imageProps.fillPatternOffsetY || 0;
}

const processImagePositionDetails = (positionType, imageProps, settings) => {
    const imageHeight = imageProps.height;
    const imageWidth = imageProps.width;
    const defaultX = 0;
    const defaultY = 0;

    let positionX;
    let positionY;

    switch (positionType) {
        case 'left-top':
            positionX = defaultX;
            positionY = defaultY;
            break;
        case 'left-center':
            positionX = defaultX;
            positionY = (settings?.height / 2) - (imageHeight / 2);
            break;
        case 'left-bottom':
            positionX = defaultX;
            positionY = settings?.height - (imageHeight + defaultY);
            break;
        case 'right-top':
            positionX = settings?.width - (imageWidth + defaultX);
            positionY = defaultY;
            break;
        case 'right-center':
            positionX = settings?.width - (imageWidth + defaultX);
            positionY = (settings?.height / 2) - (imageHeight / 2);
            break;
        case 'right-bottom':
            positionX = settings?.width - (imageWidth + defaultX);
            positionY = settings?.height - (imageHeight + defaultY);
            break;
        case 'center-top':
            positionX = (settings?.width / 2) - (imageWidth / 2);
            positionY = defaultY;
            break;
        case 'center-center':
            positionX = (settings?.width / 2) - (imageWidth / 2);
            positionY = (settings?.height / 2) - (imageHeight / 2);
            break;
        case 'center-bottom':
            positionX = (settings?.width / 2) - (imageWidth / 2);
            positionY = settings?.height - (imageHeight + defaultY);
            break;
        default:
            positionX = defaultX;
            positionY = defaultY;
    }

    imageProps.x = positionX;
    imageProps.y = positionY;
}

const processTextPositionDetails = (positionType, textProps, settings) => {
    const textHeight = textProps.totalHeight;
    const textWidth = textProps.totalWidth;
    const defaultX = 0;
    const defaultY = 0;

    let positionX;
    let positionY;

    switch (positionType) {
        case 'left-top':
            positionX = defaultX;
            positionY = defaultY;
            break;
        case 'left-center':
            positionX = defaultX;
            positionY = (settings?.height / 2) - (textHeight / 2);
            break;
        case 'left-bottom':
            positionX = defaultX;
            positionY = settings?.height - (textHeight + defaultY);
            break;
        case 'right-top':
            positionX = settings?.width - (textWidth + defaultX);
            positionY = defaultY;
            break;
        case 'right-center':
            positionX = settings?.width - (textWidth + defaultX);
            positionY = (settings?.height / 2) - (textHeight / 2);
            break;
        case 'right-bottom':
            positionX = settings?.width - (textWidth + defaultX);
            positionY = settings?.height - (textHeight + defaultY);
            break;
        case 'center-top':
            positionX = (settings?.width / 2) - (textWidth / 2);
            positionY = defaultY;
            break;
        case 'center-center':
            positionX = (settings?.width / 2) - (textWidth / 2);
            positionY = (settings?.height / 2) - (textHeight / 2);
            break;
        case 'center-bottom':
            positionX = (settings?.width / 2) - (textWidth / 2);
            positionY = settings?.height - (textHeight + defaultY);
            break;
        default:
            positionX = defaultX;
            positionY = defaultY;
    }

    textProps.x = positionX || 0;
    textProps.y = positionY || 0;
}

